import type { IconProps } from './types';
import './icons.css';

export default function ArrowRight({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-arrow-right ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M1 7.25a.75.75 0 0 0 0 1.5v-1.5ZM14 8l.53.53.53-.53-.53-.53L14 8Zm-7.03 5.97a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm1.06-13a.75.75 0 0 0-1.06 1.06L8.03.97ZM1 8.75h13v-1.5H1v1.5Zm7.03 6.28 6.5-6.5-1.06-1.06-6.5 6.5 1.06 1.06Zm6.5-7.56L8.03.97 6.97 2.03l6.5 6.5 1.06-1.06Z"
      />
    </svg>
  );
}
